import gql from "graphql-tag";
// Invite supplier
export const CREATE_MARKET_LIST_FROM_ORDER_MUTATION = gql`
  mutation createMarketlistFromOrder($orderId: String!) {
    createMarketlistFromOrder(orderId: $orderId) {
      id
      name
      items {
        ... on Cartitem {
          item
          item_name
          quantity
          price
          price_7_pct
          supplier
          supplier_name
          unit
        }
      }
    }
  }
`;